// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3q6rf","upload":"Small_upload__3Vr82","imageWrap":"Small_imageWrap__3U5_i","removeBtn":"Small_removeBtn__1GtUS"};